module.exports = __webpack_public_path__ + "static/media/action-needed.85a94fd5.svg";